<template>
  <div>
    <!-- {{JSON.stringify(dataSource)}} -->
    <dx-data-grid
      :show-borders="true"
      :ref="'batch-child-grid-' + templateData.key"
      :columns="masterDetailColumns"
      :data-source="dataSource"
      @editor-preparing="onEditorPreparing"
      @editing-start="onEditingStart"
      @content-ready="onContentReady"
      @init-new-row="onInitNewRow"
      @row-removed="onRowRemoved"
      @cell-click="onCellClick"
      @initialized="stockAdjustmentsInitialized"
    >
      <DxSearchPanel :visible="false" />
      <DxEditing
        :allow-deleting="allowEdit"
        :allow-updating="allowEdit"
        mode="cell"
      />
      <template #itemSelect="{ data }">
        <div class="custom-auto-complete">
          <span class="auto-complete-primary">{{ data.BatchNo }}</span>
          <span class="auto-complete-secondary">{{ data.SupplierCode }}</span>
          <span class="auto-complete-secondary">{{ data.SupplierName }}</span>
          <span class="auto-complete-secondary">{{ data.UseByDate }}</span>
          <span class="auto-complete-secondary">{{ data.AvailableQty }}</span>
        </div>
      </template>

      <template #use-by-cell-template="{ data }">
        <gc-friendly-date :value="data.data.UseByDate" type="date" />
      </template>

      <template #useByDateEditTemplate="{ data: cellInfo }">
        <div>
          <div>
            <DxDateBox
              :value="cellInfo.value"
              @value-changed="onDateChanged($event, cellInfo)"
              display-format="dd MMM yyyy"
              class="gc-grid-number-box-editor"
              :disabled="cellInfo.data.batchSelected"
            />
          </div>
        </div>
      </template>

      <template #available-quantity-template="{ data }">
        <DxNumberBox :value="data.data.AvailableQty" />
      </template>

      <template #quantity-template="{ data }">
        <DxNumberBox :value="data.data.AdjustedQty" />
      </template>

      <template #supplier-template="{ data }">
        <div class="gc-auto-cmp">{{ data.data.SupplierName }}</div>
      </template>
      <template #supplier-cell-template="{ data }">
        <GcDescriptionCodeCellTemplate
          :description="data.data.SupplierName"
          :code="data.data.SupplierCode"
        />
      </template>

      <template #supplierEditTemplate="{ data: cellInfo }">
        <div class="gc-auto-cmp-editor">
          <GcSupplierAutoComplete
            :on-item-click="onSupplierClicked"
            :on-value-changed="onSupplierChanged"
            :ref="'batch' + cellInfo.rowIndex"
            :data-source="SupplierDataSourceConfig"
            :value="cellInfo.value"
            :cell-info="cellInfo"
            :disabled="cellInfo.data.batchSelected"
          />
        </div>
      </template>

      <template #qtyEditTemplate="{ data }">
        <div>
          <div>
            <DxNumberBox
              :value="data.value"
              @value-changed="batchQtyChanged($event, data)"
              :format="getDecimalFormatByCode(2).Format"
              class="gc-grid-number-box-editor"
              :min="-999999999.99"
              :max="999999999.99"
              :disabled="!allowEdit"
            />
          </div>
        </div>
      </template>
    </dx-data-grid>
  </div>
</template>
<script>
import { DxDataGrid } from "devextreme-vue/data-grid";
import { DxNumberBox } from "devextreme-vue/number-box";
import BaseViewMixin from "../../src/v1/_mixins/base.view";
import { alert } from "devextreme/ui/dialog";

import { ProductBatchService } from "../_services/api/inventory/product-batch.service";

let baseLineBase = {
  BatchNo: "",
  SupplierName: "",
  SupplierCode: "",
  UseByDate: "",
  AvailableQty: 0,
  AdjustedQty: 0,
  selectedBatch: false,
  LineNo: 0,
};

let ProductBatchServiceDataSource = ProductBatchService.dataSourceConfig(
  "api/ConsumeProductBatch",
  {
    preventPagination: true,
  }
);

let SupplierDataSource = ProductBatchService.dataSourceConfig(
  "api/ProductSupplierList",
  {
    preventPagination: true,
  }
);

let addingNewBatchRow = false;

let stockAdjustmentsGridInstance = null;

let rowIndex = -1;

export default {
  components: { DxDataGrid, DxNumberBox },
  props: {
    templateData: {
      type: Object,
      default: () => {},
    },
    parentModel: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    updateReviewList: {
      type: Function,
    },
    brokenGridValidations: {
      type: Array,
    },
    allowEdit: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      dataSource: this.templateData.data.StockAdjustmentProductBatches,
      ProductBatchServiceDataSourceConfig: [],
      SupplierDataSourceConfig: [],
      batchSelected: false,
      customItemCreating: false,
    };
  },
  computed: {
    noOfRecords() {
      return this.dataSource.length;
    },
    masterDetailColumns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Batch",
          dataField: "BatchNo",
          gcType: "String",
          gcSubType: "PrimaryChildRecord",
          editorType: "dxSelectBox",
          width: 200,
          editorOptions: {
            dataSource: this.ProductBatchServiceDataSourceConfig,
            acceptCustomValue:
              this.templateData.data.IsBatchProduct === "Manual",
            onCustomItemCreating: this.onCustomItemCreating,

            displayExpr: "BatchNo",
            valueExpr: "BatchNo",
            searchExpr: ["BatchNo"],
            searchMode: "contains",
            // showClearButton: true,
            itemTemplate: "itemSelect",
            onItemClick: this.onBatchClicked,
            searchEnabled: true,
            dropDownOptions: {
              minWidth: 500,
            },
          },

          cssClass: "gc-editor-cell",
          showEditorAlways: this.allowEdit,
          allowEditing: this.allowEdit,
        },

        {
          gcLabel: "Supplier",
          gcType: "String",
          gcSubType: "RelatedRecord",
          dataField: "SupplierName",
          width: 300,
          allowEditing: true,
          cssClass: "gc-editor-cell",
          cellTemplate: this.allowEdit
            ? "supplier-template"
            : "supplier-cell-template",
          showEditorAlways: this.allowEdit,
          editCellTemplate: "supplierEditTemplate",
        },
        {
          gcLabel: "Supplier Code",
          gcType: "String",
          dataField: "SupplierCode",
          width: 300,
          allowEditing: false,
          visible: false,
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Use By Date",
          dataField: "UseByDate",
          gcType: "Date",
          // cellTemplate: this.allowEdit ? "use-by-cell-template" : "",
          allowEditing: true,
          showEditorAlways: this.allowEdit,
          editCellTemplate: "useByDateEditTemplate",
        },

        {
          gcLabel: "Available",
          dataField: "AvailableQty",
          gcType: "Decimal-6-2",
        },

        {
          gcLabel: "Quantity",
          dataField: "AdjustedQty",
          gcType: "Decimal-6-2",
          editCellTemplate: "qtyEditTemplate",
          showEditorAlways: this.allowEdit,
        },

        {
          gcLabel: "",
          gcType: "String",
          type: "buttons",
          width: 110,
          visible: this.allowEdit,
          buttons: [
            "delete",
            {
              hint: "Add Batch Line",
              icon: "plus",
              visible: true,
              onClick: this.onAddClickHandler.bind(this),
            },
          ],
        },
      ]);
    },
  },
  created() {
    if (this.allowEdit) {
      ProductBatchServiceDataSource.filter([
        ["ItemCode", "=", this.templateData.data.Code],
        ["BranchCode", "=", this.parentModel.BranchCode],
        ["SourceTransactionType", "=", ""],
        ["SourceTransactionNo", "=", 0],
        ["SourceTransactionLine", "=", 0],
        ["SourceTransactionProcessCode", "=", ""],
      ]);
      ProductBatchServiceDataSource.load().then(() => {
        this.ProductBatchServiceDataSourceConfig = ProductBatchServiceDataSource.items();
      });
      SupplierDataSource.filter([
        ["ProductCode", "=", this.templateData.data.Code],
      ]);
      SupplierDataSource.load().then(() => {
        this.SupplierDataSourceConfig = SupplierDataSource.items();
      });

      if (this.dataSource.length == 0) this.onAddClickHandler();
    }
  },
  methods: {
    onSupplierChanged(valueChangedEventArg, cellInfo) {
      cellInfo.setValue(valueChangedEventArg.value);
    },
    stockAdjustmentsInitialized(e) {
      stockAdjustmentsGridInstance = e.component;
    },
    batchValidator(e) {
      if (
        this.templateData.data.IsBatchProduct == "Manual" &&
        (e.data.BatchNo == "" || e.data.BatchNo == null)
      )
        return false;
      return true;
    },
    onSupplierClicked(e, cellInfo) {
      this.dataSource[cellInfo.rowIndex].SupplierName = e.itemData.SupplierName;
      this.dataSource[cellInfo.rowIndex].SupplierCode = e.itemData.SupplierCode;
    },
    getSupplierDataSource() {
      return ProductBatchService.dataSourceConfig("api/Supplier", {
        filter: [["Inactive", "=", "N"]],
      });
    },
    onDateChanged(valueChangedArgs, cellInfo) {
      this.dataSource[cellInfo.rowIndex].UseByDate = valueChangedArgs.value;
    },
    // eslint-disable-next-line no-unused-vars
    onCellClick(e) {
      rowIndex = e.rowIndex;
    },

    onCustomItemCreating(e) {
      if (!e.customItem) {
        e.customItem = e.text;
      }

      // let obj = Object.assign({}, baseLineBase);

      // ProductBatchServiceDataSource.items().push(
      //   Object.assign(obj, { BatchNo: e.text })
      // );
      this.customItemCreating = true;

      this.dataSource[rowIndex].BatchNo = e.text;
      this.dataSource[rowIndex].SupplierCode = "";
      this.dataSource[rowIndex].SupplierName = "";
      this.dataSource[rowIndex].UseByDate = null;
      this.dataSource[rowIndex].AvailableQty = 0;
      this.dataSource[rowIndex].ItemCode = "";
      this.dataSource[rowIndex].BranchCode = "";

      // dataSource.refresh();
    },
    // eslint-disable-next-line no-unused-vars
    onEditingStart(e) {
      // e.cancel =
      //   !this.customItemCreating && e.column.dataField == "SupplierName";
    },
    onBatchClicked(e) {
      this.batchSelected = true;
      this.dataSource[rowIndex].BatchNo = e.itemData.BatchNo;
      this.dataSource[rowIndex].SupplierCode = e.itemData.SupplierCode;
      this.dataSource[rowIndex].SupplierName = e.itemData.SupplierName;
      this.dataSource[rowIndex].UseByDate = e.itemData.UseByDate;
      this.dataSource[rowIndex].AvailableQty = e.itemData.AvailableQty;
      this.dataSource[rowIndex].ItemCode = e.itemData.ItemCode;
      this.dataSource[rowIndex].BranchCode = e.itemData.BranchCode;

      this.templateData.data.StockAdjustmentProductBatches[
        rowIndex
      ].batchSelected = true;

      stockAdjustmentsGridInstance.cellValue(
        rowIndex,
        "SupplierName",
        e.itemData.SupplierName
      );
    },

    batchQtyChanged(e, cellInfo) {
      if (e.value < 0 && -e.value > cellInfo.data.AvailableQty) {
        let errorMsg = {
          Code: this.templateData.data.Code,
          Description: this.templateData.data.Description1,
          Batch: cellInfo.data.BatchNo,
          ReturnQty: e.value,
          AvailableQty: cellInfo.data.AvailableQty,
        };
        const index = this.brokenGridValidations.findIndex(
          (x) =>
            x.Code === this.templateData.data.Code &&
            x.Batch === cellInfo.data.BatchNo
        );
        if (index > -1) {
          this.brokenGridValidations[index] = errorMsg;
        } else {
          this.brokenGridValidations.push(errorMsg);
        }
        this.$nextTick(function() {
          alert(
            `Batch ${cellInfo.data.BatchNo} for item : ${
              this.templateData.data.Description1
            }, has a write off quantity of ${this.formatNumber(
              -e.value
            )} which is more than the batch available quantity of ${this.formatNumber(
              cellInfo.data.AvailableQty
            )}`,
            "Validation Errors"
          );
        });
      } else {
        const index = this.brokenGridValidations.findIndex(
          (x) =>
            x.Code === this.templateData.data.Code &&
            x.Batch === cellInfo.data.BatchNo
        );
        if (index > -1) {
          this.brokenGridValidations.splice(index, 1);
        }
      }
      if (this.dataSource.length > 0) {
        this.dataSource[cellInfo.rowIndex].AdjustedQty = e.value;
        const maxLineNo = Math.max.apply(
          Math,
          this.dataSource.map(function(o) {
            return o.LineNo;
          })
        );
        this.dataSource[cellInfo.rowIndex].LineNo = maxLineNo + 1;

        if (e.value == 0) {
          const index = this.dataSource.findIndex(
            (line) => line.LineNo == cellInfo.data.LineNo
          );
          this.dataSource.splice(index, 1);
        }

        this.recalculateTotal();
        let isAllLinesEmpty = this.dataSource.every(
          (line) => line.AdjustedQty == 0
        );
        this.updateReviewList(this.templateData.data, isAllLinesEmpty);
      }
    },
    onRowRemoved(e) {
      this.templateData.data.totalQty -= e.key.AdjustedQty;
      let isAllLinesEmpty = this.dataSource.every(
        (line) => line.AdjustedQty == 0
      );
      this.updateReviewList(this.templateData.data, isAllLinesEmpty);
      const index = this.brokenGridValidations.findIndex(
        (x) =>
          x.Code === this.templateData.data.Code && x.Batch === e.data.BatchNo
      );
      if (index > -1) {
        this.brokenGridValidations.splice(index, 1);
      }
    },
    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },

    // eslint-disable-next-line no-unused-vars
    onEditorPreparing(e) {
      // let currentRowIndex = e.row && e.row.rowIndex;
      // if (e.row.rowType === "data" && e.dataField === "SupplierName") {
      //   e.editorOptions.readOnly = !this.templateData.data
      //     .StockAdjustmentProductBatches[currentRowIndex].isCustomBatch;
      // }
      // if (e.row.rowType === "data" && e.dataField === "UseByDate") {
      //   e.editorOptions.readOnly =
      //     !this.templateData.data.StockAdjustmentProductBatches[currentRowIndex]
      //       .isCustomBatch && this.templateData.data.IsBatchProduct == "Manual";
      // }
      if (e.row.rowType === "data" && e.dataField === "BatchNo") {
        e.editorOptions.required = true;
      }
    },
    onInitNewRow(e) {
      e.data.AdjustedQty = 0;
    },
    onContentReady(e) {
      this.$logger.debug("content ready", e);

      if (addingNewBatchRow) {
        addingNewBatchRow = false;
        let grid = this.$refs["batch-child-grid-" + this.templateData.key]
          .instance;

        let recordCount = grid.getDataSource().items().length;
        this.$logger.debug(recordCount);
        if (recordCount > 0) {
          let editElement = grid.getCellElement(recordCount - 1, 0);
          grid.focus(editElement);
          editElement.click();
        }
      }
    },

    onAddClickHandler() {
      this.customItemCreating = false;
      let obj = Object.assign({}, baseLineBase);
      this.dataSource.push(obj);
      if (this.$refs["batch-child-grid-" + this.templateData.key]) {
        let grid = this.$refs["batch-child-grid-" + this.templateData.key]
          .instance;

        grid.repaint();
      }
      addingNewBatchRow = true;
    },

    recalculateTotal() {
      let totalBatchPickedQty = 0;
      this.dataSource.forEach((x) => {
        totalBatchPickedQty += x.AdjustedQty;
      });

      this.templateData.data.totalQty = totalBatchPickedQty;

      this.templateData.data.StockAdjustmentProductBatches = this.dataSource;
    },
  },
  watch: {
    noOfRecords: {
      handler: function(value) {
        // add a record if the no of items in the datasource is 0
        if (this.allowEdit && value == 0) {
          this.onAddClickHandler();
        }
      },
    },
  },
};
</script>
<style>
/* @import "../dx-styles.scss"; */
</style>
